// libs
import React from 'react';

import { cn } from '@lyearn/style';
import CellBackdrop from '@/modules/corporate/modules/database/fields/components/CellBackdrop';
// hooks
import useSelectEditableCell from '@/modules/corporate/modules/database/fields/hooks/useSelectEditableCell';
// types
import { CellProps } from '@/modules/corporate/modules/database/types';

// components
import DatabaseSelect from '../components/DatabaseSelect';
// styles
import { getClasses, rectPositionStyles } from './styles';

function EditableCell(props: CellProps) {
  const { toggleIsEditing, column, cellData, rowData, onAction } = props;
  const selectProps = useSelectEditableCell({
    documentId: rowData._id,
    fieldId: column.id,
    multiple: false,
    onAction,
    toggleIsEditing,
  });

  return (
    <CellBackdrop onClickAway={toggleIsEditing}>
      {(rect) => (
        <DatabaseSelect
          className={cn('fixed', rectPositionStyles(rect))}
          classes={getClasses(rect.height)}
          field={column.field}
          value={cellData?.value}
          {...selectProps}
        />
      )}
    </CellBackdrop>
  );
}

export default EditableCell;
